import useReveal from './useReveal';
import { experience, certifications } from '../data';

const palette = { accent: { border: 'rgba(0,229,255,0.3)', color: '#00e5ff', bg: 'rgba(0,229,255,0.05)' }, '': { border: '#1a3040', color: '#5a8a9f', bg: 'rgba(255,255,255,0.04)' } };

export default function Experience() {
  const [refL, visL] = useReveal();
  const [refR, visR] = useReveal();

  return (
    <section id="experience" style={{ background: '#0b1318', borderTop: '1px solid #1a3040', position: 'relative', zIndex: 1 }}>
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '6rem 3rem' }}>
        <div style={{ fontFamily: "'Space Mono', monospace", fontSize: '0.7rem', color: '#00e5ff', letterSpacing: '0.25em', textTransform: 'uppercase', marginBottom: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
          04 // Expérience
          <span style={{ flex: 1, maxWidth: 80, height: 1, background: '#00e5ff', opacity: 0.4 }} />
        </div>
        <h2 style={{ fontSize: 'clamp(2rem, 4vw, 3.2rem)', fontWeight: 800, lineHeight: 1.1, letterSpacing: '-0.02em', marginBottom: '3rem', color: '#e2f0f5' }}>
          Parcours <span style={{ color: '#00e5ff' }}>professionnel</span>
        </h2>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '4rem' }}>
          {/* Timeline */}
          <div ref={refL} style={{ position: 'relative', paddingLeft: '2rem', opacity: visL ? 1 : 0, transform: visL ? 'none' : 'translateY(30px)', transition: 'opacity 0.7s ease, transform 0.7s ease' }}>
            <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 1, background: 'linear-gradient(to bottom, #00e5ff, transparent)', opacity: 0.3 }} />
            {experience.map((e, i) => (
              <div key={i} style={{ position: 'relative', paddingBottom: '3rem', paddingLeft: '2.5rem' }}>
                <div style={{ position: 'absolute', left: '-2rem', width: 10, height: 10, background: '#00e5ff', border: '2px solid #050a0e', borderRadius: '50%', top: '0.4rem' }} />
                <div style={{ fontFamily: "'Space Mono', monospace", fontSize: '0.7rem', color: '#00e5ff', letterSpacing: '0.1em', marginBottom: '0.5rem' }}>{e.date}</div>
                <div style={{ fontSize: '1.05rem', fontWeight: 700, marginBottom: '0.25rem', color: '#e2f0f5' }}>{e.title}</div>
                <div style={{ fontSize: '0.85rem', color: '#5a8a9f', marginBottom: '0.8rem' }}>{e.company}</div>
                <ul style={{ listStyle: 'none', padding: 0 }}>
                  {e.bullets.map((b, j) => (
                    <li key={j} style={{ fontSize: '0.85rem', color: '#5a8a9f', lineHeight: 1.8, marginBottom: '0.4rem', paddingLeft: '1rem', position: 'relative' }}>
                      <span style={{ position: 'absolute', left: 0, color: '#00e5ff', fontFamily: "'Space Mono', monospace", fontSize: '0.7rem', top: '0.15em' }}>→</span>
                      {b}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Education + Certs */}
          <div ref={refR} style={{ opacity: visR ? 1 : 0, transform: visR ? 'none' : 'translateY(30px)', transition: 'opacity 0.7s 0.15s ease, transform 0.7s 0.15s ease' }}>
            <div style={{ marginBottom: '2.5rem' }}>
              <div style={{ fontFamily: "'Space Mono', monospace", fontSize: '0.7rem', color: '#00e5ff', letterSpacing: '0.2em', textTransform: 'uppercase', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
                Formation <span style={{ flex: 1, maxWidth: 60, height: 1, background: '#00e5ff', opacity: 0.4 }} />
              </div>
              <div style={{ background: '#0f1c24', border: '1px solid #1a3040', padding: '2rem' }}>
                <div style={{ fontFamily: "'Space Mono', monospace", fontSize: '0.7rem', color: '#00e5ff', marginBottom: '0.4rem' }}>2023 — Présent</div>
                <div style={{ fontWeight: 700, marginBottom: '0.3rem', color: '#e2f0f5' }}>Ingénierie Informatique & IA</div>
                <div style={{ fontSize: '0.85rem', color: '#5a8a9f' }}>ENSAM Casablanca</div>
              </div>
            </div>

            <div>
              <div style={{ fontFamily: "'Space Mono', monospace", fontSize: '0.7rem', color: '#00e5ff', letterSpacing: '0.2em', textTransform: 'uppercase', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
                Certifications <span style={{ flex: 1, maxWidth: 60, height: 1, background: '#00e5ff', opacity: 0.4 }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
                {certifications.map(c => {
                  const p = palette[c.color] || palette[''];
                  return (
                    <span key={c.label} style={{ fontFamily: "'Space Mono', monospace", fontSize: '0.72rem', padding: '0.5rem 1rem', background: p.bg, border: `1px solid ${p.border}`, color: p.color }}>
                      {c.label}
                    </span>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
